module.exports = __webpack_public_path__ + "static/media/zw.c698f808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/zw.svg
// module id = 295
// module chunks = 0